import { Breadcrumbs, Button, Stack } from "@mui/material";

import { useFilterContext } from "../FilterContext";

const FilterItemCategory = () => {
  const { filterData, setFilterData, filterOptions } = useFilterContext();

  const handleChange = (value: string) => {
    let newValue = [];
    if (filterData.category.includes(value)) {
      newValue = filterData.category.filter((v) => v !== value);
    } else {
      newValue = [...filterData.category, value];
    }
    setFilterData({
      ...filterData,
      category: newValue.length === filterOptions.categoryOptions.length ? [] : newValue,
    });
  };

  return (
    <Stack spacing={0} className="flex-wrap">
      <Breadcrumbs
        maxItems={10000}
        separator=""
        aria-label="breadcrumb"
        sx={{
          ".MuiBreadcrumbs-ol": {
            flexWrap: "nowrap",
          },
          ".MuiBreadcrumbs-separator": {
            margin: "0 4px",
          },
        }}
      >
        {filterOptions.categoryOptions.map((item) => {
          return (
            <Button
              key={item.label}
              size="small"
              variant={filterData.category.includes(item.label) ? "contained" : "outlined"}
              className="whitespace-nowrap"
              onClick={() => handleChange(item.label)}
              startIcon={<item.icon />}
              sx={{
                textTransform: "capitalize",
                whiteSpace: "nowrap",
              }}
            >
              {item.label}
            </Button>
          );
        })}
      </Breadcrumbs>
    </Stack>
  );
};

export default FilterItemCategory;
